import DocumentTitle from 'react-document-title';
import * as React from 'react';

export namespace AppDocumentTitle {
  export interface Props {
    title: string;
    titleFirst?: boolean;
  }
}

class AppDocumentTitle extends React.Component<AppDocumentTitle.Props, {}> {
  render() {
    const { title, titleFirst = false, children } = this.props;
    const organizationName = window.DEPLOYMENT_CONFIG.organization.name;
    const docTitle = titleFirst ? `${title} | ${organizationName}` : `${organizationName} | ${title}`;
    return <DocumentTitle title={docTitle}>{children}</DocumentTitle>;
  }
}

export default AppDocumentTitle;
